import auth from './auth';
import control from './control';
import more from './more';
import settings from './settings';

export default {
  ...auth,
  ...control,
  ...more,
  ...settings,
};
